import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, onSnapshot } from "firebase/firestore";

const WHATSAPP_NUMBER = '573013346595'; // Cambia a tu número si es necesario

const NewProductsSection = () => {
  const [newProducts, setNewProducts] = useState([]);

  useEffect(() => {
    const unsub = onSnapshot(collection(db, "productos"), (snap) => {
      const productosNuevos = snap.docs
        .map(doc => ({ id: doc.id, ...doc.data() }))
        .filter(prod => prod.isNew);
      setNewProducts(productosNuevos);
    });
    return () => unsub();
  }, []);

  if (newProducts.length === 0) {
    return <div className="text-gray-400 italic text-center mt-8">No hay productos nuevos aún.</div>;
  }

  return (
    <section className="container mx-auto py-12">
      <h2 className="text-2xl sm:text-3xl font-bold mb-8 text-center">Novedades de Atlantis Fish</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
        {newProducts.map(prod => {
          const whatsappLink = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
            `Hola, estoy interesado en el producto "${prod.name}". ¿Me puedes dar más información?`
          )}`;
          return (
            <div key={prod.id} className="bg-white/60 rounded-xl shadow-lg p-6 flex flex-col">
              <img
                src={prod.image || "https://via.placeholder.com/400x200?text=Sin+imagen"}
                alt={prod.name}
                className="w-full h-40 object-cover rounded-xl mb-4"
              />
              <h3 className="text-lg font-bold text-blue-900 mb-1">{prod.name}</h3>
              <div className="text-sm text-gray-600 mb-3">{prod.category}</div>
              <p className="text-gray-700 text-sm mb-4 line-clamp-3">{prod.description}</p>
              <div className="mt-auto font-bold text-xl text-primary mb-2">
                {Number(prod.price).toLocaleString("es-CO", { style: "currency", currency: "COP", minimumFractionDigits: 0 })}
              </div>
              <a
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-lg font-semibold text-center transition-all mt-2"
                style={{ display: "inline-block" }}
              >
                Preguntar por WhatsApp
              </a>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default NewProductsSection;
